import axios from 'axios'
import store from '../store'

const instance = axios.create({
  baseURL: 'http://localhost/fantacalcio/backend/api'
})

// Intercetta e aggiunge il token
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Logout forzato SOLO su token mancante/scaduto/non valido (401 - vedi
// Auth::getAuthenticatedUserFromHeader() in Controller.php, l'unico punto che risponde con
// questo status). Prima veniva forzato su QUALUNQUE errore (403 accesso negato, 503
// manutenzione, errori di rete, ecc.), sloggando l'utente anche quando il problema non aveva
// nulla a che fare col login - es. durante la manutenzione, il primo 503 ricevuto sloggava
// subito lo standard user prima ancora che potesse vedere la schermata di attesa.
// Va registrato su QUESTA istanza: e' quella che main.js espone come `this.axios`
// nei componenti (vue-axios usa l'ultima istanza passata a .use(VueAxios, ...)),
// non il modulo "axios" di default - un interceptor li' non intercetterebbe mai
// le vere richieste dell'app.
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch('logout').finally(() => {
        window.location.href = '/login'
      })
    }
    return Promise.reject(error)
  }
)

export default instance
